import styled from '@emotion/styled';
import { colorMap, defaultLableFontSize } from '../../../common/componentUtils';

export const StyledIconLabel = styled.div`
	display: flex;
	align-items: center;
	color: #171717;
`;

export const StyledLabel = styled.span`
	padding-left: 8px;
	font-size: ${defaultLableFontSize}px;
`;

export const StyledGhostComponent = styled.div<{
	isAnnotation: boolean;
	signerColor: string;
	isCheckboxGroup: boolean;
}>`
	position: absolute;
	box-sizing: border-box;
	opacity: 0.7;
	top: 0;
	left: 0;
	padding: 4px;
	display: none;
	flex-direction: ${props => (props.isCheckboxGroup ? 'column' : 'row')};
	align-items: ${props => (props.isCheckboxGroup ? 'flex-start' : 'center')};
	gap: ${props => (props.isCheckboxGroup ? '4px' : '0')};
	justify-content: center;
	z-index: 51;
	cursor: crosshair;
	user-select: none;
	border: 1px solid;
	border-radius: 4px;
	background-color: ${props => getBackgroundColor(props)};
	border-color: ${props => getBorderColor(props)};
`;

const getBackgroundColor = props => {
	// if (props.isTextAnnotation) {
	// 	return 'transparent';
	// } else {
	// 	return colorMap[props.signerColor]?.backgroundColor;
	// }
	return colorMap[props.signerColor]?.backgroundColor;
};
const getBorderColor = props => {
	// if (props.isAnnotation) {
	// 	return 'transparent';
	// } else {
	// 	return colorMap[props.signerColor]?.borderColor;
	// }
	return colorMap[props.signerColor]?.borderColor;
};
